import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import * as log from "loglevel";
import { getMessage } from "CONFIG/i18n";

// websoket
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";

// components
import Header from "./Header";
import Spinner from "COMPONENTS/Spinner/Spinner";

// SELECTORS
import { selectSessionTitle } from "COMPONENTS/Sessions/selectors";
import { isMessageArrived, showMessageToast } from "COMPONENTS/Chat/selectors";
import { selectSessionKey, selectUserToken, selectEndUserToken } from "COMPONENTS/MainLayout/selectors";
import {
  selectCurrentParticipantUniqueId,
  selectSnapshoteeId,
  selectSnapshoterId,
  selectSnapshotPermissionReply,
  selectIsSnapshotTaken,
  selectOrganiser,
  selectShowSnapshot,
  selectIsSnapShotRunning,
  getRecordingMethod,
  getIsRecording,
  getRecordingTarget,
  getIsScreenMasking,
  getIsVideoTransform,
  getShowPreviewModal,
  getAudioDeviceId,
  getVideoDeviceId,
  getFacingMode,
  getIsVirtualBackground,
  getSelectedBackground,
  getDisableCanvasEdit,
  selectSessionType,
  getModalRecordingMessage,
  getEnableVideoBlur,
} from "REDUX/Selector/SessionSelector";
import {
  selectUserRole,
  selectParticipantId,
  selectActiveCanvas,
  getFrameLockedParticipantId
} from "COMPONENTS/Whiteboard/selectors";
import {
  getLocationParticipants,
  selectLocationPermissionReply,
  selectLocationPermissionReplyStatus
} from "COMPONENTS/Location/selectors";
import { 
  selectSessionStatus,
  getShowAudioVideoComponentFlag
} from "COMPONENTS/Dashboard/selectors";
import {
  getAppEmulationPermission,
  getAppEmulationPermissionReply,
  getparticipantLeftUniqueId,
  getparticipantJoinedUniqueId,
  getisSessionEnded,
  getparticipantDeniedUniqueId
} from "COMPONENTS/AppEmulation/AppEmulationSelector";
import {
  getModules,
  getAdmittedParticipants,
  getAllParticipants,
  getWebRtcPermissionRequest,
  getWebRtcPermissionReply,
  getHeaderIcons,
  selectLatestUpdatedParticipant,
  getEvictedParticipantPermissionRequest,
  selectWebRtcPermissionReplyStatus,
  selectSessionEndedFlag,
  selectPresenter,
  selectLocation,
  selectLocationSharing,
  getKmsStatus,
  getShowKmsStatus,
  getCallStatus,
  getIsOrganizer,
  getSnapshotCameraPermissionflag,
  getSnapshotCameraBusyflag,
  selectUserName,
  getCustomerId,
  getEvictedParticipantDetails,
  selectDeactiveModules,
  selectSubModulesAudioVideo,
  getScreenMaskSetting,
  getIsReductionLogs,
  getOperatorExclusiveRecordingControl,
  getDisableInitiatingCoBrowse
} from "./selectors";
import {
  getCustomerCoBrowsePermissionRequest,
  getCustomerCoBrowsePermissionReply,
  selectCoBrowseType,
  getShowCustomerCoBrowse,
  getRoomId,
  getCustomerCoBrowseStarted,
  getLayoutCode
} from "COMPONENTS/CustomerCoBrowse/CustomerCoBrowseSelector"
import {
  getShowInboundCoBrowse, 
  setEndInboundCoBrowse,
  setIsInboundCobrowseMinimize,
} from "COMPONENTS/InboundCoBrowse/InboundCoBrowseSelector"
import {
  selectIsDisabledMenu,
} from "COMPONENTS/QRCode/QRCodeComponent/QRCodeSelector";
import {
  getContractInfo,
  getIsContractInfoModalOpened
} from "@/Redux/Selector/SessionSelector"
import {
  getSessionName
} from "@/Redux/Selector/SupportCenterSelector"
import {
  getSpeedTestParticipantId,
  getSpeedTestParticipantName,
  getSpeedTestDisconnectUserName,
} from "@/Redux/Selector/RoomMetaDataSelector"

// ACTIONS
import {
  addLocationParticipantId,
  updateLocationPermissionReply,
  stopLocationShare
} from "COMPONENTS/Location/LocationAction";
import { setToken } from "COMPONENTS/UserJoin/UserJoinAction";
import { leaveSessionAction, sessionActions, headerAction, appEmulationAction, audioVideoAction, customerCoBrowseActionV2,
  customerCoBrowseAction,
} from "CONFIG/ActionFactory";
import {
  displayMessage,
  showMessageArrivedToastAction,
  setMessagesRead
} from "COMPONENTS/Chat/ChatAction";

// UTILS
import { CONFIG, DEVICE_ORIENTATION, ERROR, audiovideoSubModules} from "UTILS/Constants";
import { mediaStatus, socketMessage, webRtcMessageId } from "WEBSOCKET/constants";
import { removeTrailingSlash, postMesageToCoBrowseIframeUtility } from "UTILS/Utility";
import { selectCoBrowseBaseUrl, getEndCustomerCBSession } from "../../CustomerCoBrowse/CustomerCoBrowseSelector";
import { getDeviceOrientation } from '@/Redux/Selector/UserSelector';

export class DashHeaderContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      spinnerVisibility: false
    }
  }
  handleEndSession = () => {
    this.setSpinnerVisibility(true)
    // Post End_session_without_confirmation to iframe on end loookit session
    if (this.props.showCustomerCoBrowse) {
      postMesageToCoBrowseIframeUtility(this.props.endUserToken, this.props.coBrowseBaseUrl);
      console.log("Post End_session_without_confirmation on end loookit session")
      setTimeout(() => {
        customerCoBrowseAction.endCustomerCoBrowse()
      }, 500);// wait until message gets posted to CB server(iframe) properly then close CB container
    }

    leaveSessionAction.endSessionAndCleanUp(this.props.sessionKey).then(
      data => {
        // do this in _END_SESSION
        // this.props.history.push(CONFIG.path.createSession);
        sessionStorage.removeItem(this.props.token);
      },
      err => {
        this.setSpinnerVisibility(false)
        if (err.code !== ERROR.NOT_AUTHORIZED) {
          let message = getMessage(err.code);
          toastr.error(message);
          log.error("Error:", err);
        }
      }
    );
    // Remove co-browsing reconnect destination after eXcloser meeting
    sessionStorage.removeItem('reconnectionUrl');
  };

  handleLeaveSession = () => {
    let isPasscodeSession = this.props.passcode;
    // Post End_session_without_confirmation to iframe on leave loookit session
    if (this.props.showCustomerCoBrowse) {
      postMesageToCoBrowseIframeUtility(this.props.endUserToken, this.props.coBrowseBaseUrl);
      console.log("Post End_session_without_confirmation on leave loookit session")
      setTimeout(() => {
        customerCoBrowseAction.leaveCustomerCoBrowse(this.props.uniqueId)
        isPasscodeSession ?
          this.props.history.push(CONFIG.path.joinWithPasscode)
          :
          this.props.history.push(
            `${CONFIG.path.userJoin}?sessionKey=${this.props.sessionKey}`
          );
      }, 500);// wait until message gets posted to CB server(iframe) properly then close CB container
    } else {
      isPasscodeSession ?
        this.props.history.push(CONFIG.path.joinWithPasscode)
        :
        this.props.history.push(
          `${CONFIG.path.userJoin}?sessionKey=${this.props.sessionKey}`
        );
    }
    // Remove co-browsing reconnects after leaving eXcloser meeting
    sessionStorage.removeItem('reconnectionUrlForFollower');
  };

  evictAction = (participantId) => {
    // fix added for WAAG-4652 : if participant refreshes then, will have to get changed/latest uniqueId of participant and send evict call to server.
    this.props.admittedParticipants.map((participant) => {
      if (participant.participantId === participantId) {
        audioVideoAction.evictParticipant(
          this.props.sessionKey,
          participant.uniqueId
        )
      }
    })
  }

  execSpeedTest = (participantId) => {
    this.props.admittedParticipants.map((participant) => {
      if (participant.participantId === participantId) {
        const message = {
          data : {
            category: socketMessage.category.SESSION,
            action: socketMessage.subCategories.SESSION.EXEC_SPEED_TEST,
            sessionKey: this.props.sessionKey,
            remoteId: participant.uniqueId,
            name: participant.userName,
          }
        };
        this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);
      }
    })
  }

  setLocationPopup = value => {
    this.props.setLocationPopup(value);
  };
  isPresenter = () => {
    return this.props.uniqueId === this.props.presenter;
  };

  setSpinnerVisibility = (value) => {
    this.setState({
      spinnerVisibility: value
    })
  }

  renderSpinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  saveSessionData = () => {
    this.setSpinnerVisibility(true);
    sessionActions.setSaveSessionDataFlag(true);
    setTimeout(() => {
      sessionActions.saveSessionData(this.props.sessionKey).then(() => {
        this.setSpinnerVisibility(false);
        toastr.success(getMessage("SESSION_SAVE_SUCCESS"));
      },
      error => {
        this.setSpinnerVisibility(false);
        toastr.error(getMessage("SESSION_SAVE_ERROR"));
      });
    }, 10000);
  }

  setDeviceOrientation(){
    if (window.matchMedia("(orientation: portrait)").matches) {
      headerAction.setDeviceOrientation(DEVICE_ORIENTATION.PORTRAIT);
    } else if (window.matchMedia("(orientation: landscape)").matches) {
      headerAction.setDeviceOrientation(DEVICE_ORIENTATION.LANDSCAPE);
    }
  }

  componentDidMount = () => {

    if (sessionStorage.getItem('reconnectionUrl') || sessionStorage.getItem('reconnectionUrlForFollower')) {
      let count = 0;
      const timerId = setInterval(() => {
        if (this.isPresenter() && sessionStorage.getItem('reconnectionUrl') && !this.props.showCustomerCoBrowse) {
          customerCoBrowseActionV2.updateParticipantCoBrowseStatus(this.props.uniqueId, true);
          customerCoBrowseActionV2.showHideCustomerCoBrowse(true);
          customerCoBrowseActionV2.setAppEmulationUrl(sessionStorage.getItem('reconnectionUrl'));
          clearInterval(timerId);
        } else if (!this.isPresenter() && sessionStorage.getItem('reconnectionUrlForFollower') && !this.props.showCustomerCoBrowse) {
          //If the WS's PERMISSION _ REPLY is not called before the REST joinSession is called, eXcloserSV sees it as a "nonexistent follower"
          var message = {
            data: {
              category: socketMessage.category.APP_EMULATION,
              action: webRtcMessageId.PERMISSION_REPLY,
              sessionKey: this.props.sessionKey,
              isGranted: true
            }
          };
          this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);

          // For follower reconnection, do the following
          customerCoBrowseActionV2.setAppEmulationUrlForFollower(sessionStorage.getItem('reconnectionUrlForFollower'))

          // CustomerCoBrowse WS as usual
          var message = {
            data: {
              category: socketMessage.category.CUSTOMER_CO_BROWSE,
              action: socketMessage.subCategories.CUSTOMER_CO_BROWSE.PERMISSION_REPLY,
              sessionKey: this.props.sessionKey,
              isGranted: true
            }
          };
          this.props.sendWebsocketMessage(socketMessage.events.MESSAGE, message);

          customerCoBrowseActionV2.updateCustomerCoBrowsePermissionReply(true);
          customerCoBrowseActionV2.showHideCustomerCoBrowse(true);
      
          clearInterval(timerId);
        }

        // Since the componentDidMount is called twice by the react specification, setInterval moves two times.
        // Since clearInterval after reconnection can only stop one setInterval, the extra setInterval should be stopped after one minute.
        if (count > 20) {
          clearInterval(timerId);
        }
        count++;
      }, 3000);
      this.setState({timerId})
    }

    window.addEventListener("resize", this.setDeviceOrientation);

    if (document.visibilityState === 'visible') {
      document.addEventListener('visibilitychange', this.setDeviceOrientation);
    }

    this.setDeviceOrientation();
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.setDeviceOrientation);
    
    if (document.visibilityState === 'visible') {
      document.removeEventListener('visibilitychange', this.setDeviceOrientation);
    }
  }

  componentDidUpdate(prevProps) {
    // Toastr msg for agent mute/unmute users by clicking on waiting area Audio/Video icons.
    if(prevProps.currentParticipantMediaStatus.audioStatus !== this.props.currentParticipantMediaStatus.audioStatus) {
      if(this.props.currentParticipantMediaStatus.audioStatus === mediaStatus.MUTED_BY_AGENT){
        console.log("AUDIO_MUTED_BY_AGENT")
        toastr.info(getMessage("AUDIO_MUTED_BY_AGENT"));
      } else if(this.props.currentParticipantMediaStatus.audioStatus === mediaStatus.UNMUTED
        && this.props.currentParticipantMediaStatus.mediaStatusChangeByAgent){
        console.log("AUDIO_UNMUTED_BY_AGENT")
        toastr.info(getMessage("AUDIO_UNMUTED_BY_AGENT"));
      }
    }

    if(prevProps.currentParticipantMediaStatus.videoStatus !== this.props.currentParticipantMediaStatus.videoStatus) {
      if(this.props.currentParticipantMediaStatus.videoStatus === mediaStatus.MUTED_BY_AGENT){
        toastr.info(getMessage("VIDEO_MUTED_BY_AGENT"));
      } else if(this.props.currentParticipantMediaStatus.videoStatus === mediaStatus.UNMUTED
        && this.props.currentParticipantMediaStatus.mediaStatusChangeByAgent){
        toastr.info(getMessage("VIDEO_UNMUTED_BY_AGENT"));
      }
    } 
  }

  isEnableShowPreview = () => {
    return true;
  }

  /**
   * Turn ContractInfoModal ON <-> OFF
   */
  toggleContractInfoModal = () => {
    const contractInfo = this.props.contractInfo;
    if (!contractInfo) {
      return;
    }
    // One item
    // [{ label, url }]
    if (contractInfo.length === 1) {
      const winopen = window.open();
      winopen.opener = null;
      winopen.location = contractInfo[0].url;
      return;
    }
    // Many item
    // [{ label, url }, { label, url }, ... ]
    sessionActions.setIsContractInfoModalOpened(!this.props.isContractInfoModalOpened)
  }

  render() {
    // let splithash = window.location.hash ? window.location.hash.split("/") : [];
    // let splitpath = splithash.length > 1 ? splithash[1].split('?') : [];
    // let isDashboard = splitpath.length > 0 ? splitpath[0] === "dashboard" ? true : false : false;
    let isDashboard = removeTrailingSlash(this.props.history.location.pathname) === CONFIG.path.dashboard;
    return (
      <>
        {isDashboard ?
          <React.Fragment>
            {this.renderSpinner()}
            <Header
              locationPermissionReply={this.props.locationPermissionReply}
              messagesRead={this.props.messagesRead}
              setMessagesRead={this.props.setMessagesRead}
              modules={this.props.modules}
              sessionTitle={this.props.sessionTitle}
              admittedParticipants={this.props.admittedParticipants}
              allParticipants={this.props.allParticipants}
              sessionKey={this.props.sessionKey}
              sendWebsocketMessage={this.props.sendWebsocketMessage}
              token={this.props.token}
              webRtcPermissionRequest={this.props.webRtcPermissionRequest}
              webRtcPermissionReply={this.props.webRtcPermissionReply}
              webRtcPermissionReplyStatus={this.props.webRtcPermissionReplyStatus}
              sessionActions={sessionActions}
              headerAction={headerAction}
              audioVideoAction={audioVideoAction}
              uniqueId={this.props.uniqueId}
              userRole={this.props.userRole}
              handleEndSession={this.handleEndSession}
              headerIcons={this.props.headerIcons}
              handleLeaveSession={this.handleLeaveSession}
              latestUpdatedParticipant={this.props.latestUpdatedParticipant}
              isSessionEnded={this.props.isSessionEnded}
              displayMessage={this.props.displayMessage}
              showMessageToast={this.props.showMessageToast}
              showMessageArrivedToastAction={
                this.props.showMessageArrivedToastAction
              }
              isMessageArrived={this.props.isMessageArrived}
              snapshoteeId={this.props.snapshoteeId}
              snapshoterId={this.props.snapshoterId}
              snapshotPermissionReply={this.props.snapshotPermissionReply}
              sessionStatus={this.props.sessionStatus}
              presenter={this.props.presenter}
              isSnapshotTaken={this.props.isSnapshotTaken}
              isLocation={this.props.isLocation}
              setLocationPopup={this.setLocationPopup}
              locationPermissionReplyStatus={
                this.props.locationPermissionReplyStatus
              }
              locationParticipants={this.props.locationParticipants}
              addLocationParticipantId={this.props.addLocationParticipantId}
              updateLocationPermissionReply={
                this.props.updateLocationPermissionReply
              }
              updateLocationParticipantId={this.props.updateLocationParticipantId}
              isLocationSharing={this.props.isLocationSharing}
              stopLocationShare={this.props.stopLocationShare}
              isPresenter={this.isPresenter()}
              organiser={this.props.organiser}
              activeCanvas={this.props.activeCanvas}
              frameLockedParticipantId={this.props.frameLockedParticipantId}
              participantLeftUniqueId={this.props.participantLeftUniqueId}
              participantJoinedUniqueId={this.props.participantJoinedUniqueId}
              participantDeniedUniqueId={this.props.participantDeniedUniqueId}
              screenSharingParticipantId={this.props.screenSharingParticipantId}
              kmsConnectionStatus={this.props.kmsConnectionStatus}
              showKmsConnectionStatus={this.props.showKmsConnectionStatus}
              logoUrl={this.props.logoUrl}
              isCallEnded={this.props.isCallEnded}
              isOrganizer={this.props.isOrganizer}
              setToken={this.props.setToken}
              isCameraPermissionGranted={this.props.isCameraPermissionGranted}
              isCameraBusy={this.props.isCameraBusy}
              setSpinnerVisibility={this.setSpinnerVisibility}
              callMediaType={this.props.callMediaType}
              loggingLevel={this.props.loggingLevel}
              saveSessionData={this.saveSessionData}
              language={this.props.language}
              uriIdentifier={this.props.uriIdentifier}
              appEmulationPermission={this.props.appEmulationPermission}
              appEmulationPermisssionReply={this.props.appEmulationPermisssionReply}
              appEmulationAction={appEmulationAction}
              appEmulationIsSessionEnded={this.props.appEmulationIsSessionEnded}
              coBrowsePermission={this.props.coBrowsePermission}
              coBrowsePermisssionReply={this.props.coBrowsePermisssionReply}
              userName={this.props.userName}
              customerId={this.props.customerId}
              coBrowseJoinedParticipantUniqueId={this.props.coBrowseJoinedParticipantUniqueId}
              participantDeniedCoBrowseUniqueId={this.props.participantDeniedCoBrowseUniqueId}
              participantLeftCoBrowseUniqueId={this.props.participantLeftCoBrowseUniqueId}
              showCoBrowse={this.props.showCoBrowse}
              coBrowseSessionStatus={this.props.coBrowseSessionStatus}
              snapshotPermissionStatus={this.props.snapshotPermissionStatus}
              pluginNotInstalledParticipantIds={this.props.pluginNotInstalledParticipantIds}
              customerUriIdentifier={this.props.customerUriIdentifier}
              customerCoBrowsePermissionRequest={this.props.customerCoBrowsePermissionRequest}
              customerCoBrowsePermissionReply={this.props.customerCoBrowsePermissionReply}
              cobrowseType={this.props.cobrowseType}
              showCustomerCoBrowse={this.props.showCustomerCoBrowse}
              isInboundCobrowseMinimize={this.props.isInboundCobrowseMinimize}
              endInboundCoBrowse={this.props.endInboundCoBrowse}
              showInboundCoBrowse={this.props.showInboundCoBrowse}
              roomId={this.props.roomId}
              layoutCode={this.props.layoutCode}
              endUserToken={this.props.endUserToken}
              coBrowseBaseUrl={this.props.coBrowseBaseUrl}
              endCustomerCBSession={this.props.endCustomerCBSession}
              showSnapshot={this.props.showSnapshot}
              isSnapshotRunning={this.props.isSnapshotRunning}
              customerCoBrowseStarted={this.props.customerCoBrowseStarted}
              evictAction={this.evictAction}
              evictedParticipantDetails={this.props.evictedParticipantDetails}
              isUserEvicted={this.props.isUserEvicted}
              showAudioVideoComponent={this.props.showAudioVideoComponent}
              recordingMethod={this.props.recordingMethod}
              modalRecordingMessage={this.props.modalRecordingMessage}
              isRecording={this.props.isRecording}
              recordingTarget={this.props.recordingTarget}
              currentParticipantMediaStatus={this.props.currentParticipantMediaStatus}
              isScreenMasking={this.props.isScreenMasking}
              deactiveModules={this.props.deactiveModules}
              showPreviewModal={this.props.showPreviewModal}
              isEnableShowPreview={this.isEnableShowPreview()}
              audioDeviceId={this.props.audioDeviceId}
              videoDeviceId={this.props.videoDeviceId}
              facingMode={this.props.facingMode}
              screenMaskSetting={this.props.screenMaskSetting}
              isReductionLogs={this.props.isReductionLogs}
              isVideoTransform={this.props.isVideoTransform}
              isVirtualBackground={this.props.isVirtualBackground}
              selectedBackground={this.props.selectedBackground}
              disableCanvasEdit={this.props.disableCanvasEdit}
              isDisabledMenu={this.props.isDisabledMenu}
              sessionType={this.props.sessionType}
              contractInfo={this.props.contractInfo}
              isContractInfoModalOpened={this.props.isContractInfoModalOpened}
              toggleContractInfoModal={this.toggleContractInfoModal}
              userProfileData={this.props.userProfileData}
              sessionName={this.props.sessionName}
              orientation={this.props.orientation}
              operatorExclusiveRecordingControl={this.props.operatorExclusiveRecordingControl}
              disableInitiatingCoBrowse={this.props.disableInitiatingCoBrowse}
              enableVideoBlur={this.props.enableVideoBlur}
              execSpeedTest={this.execSpeedTest}
              speedTestParticipantId={this.props.speedTestParticipantId}
              speedTestParticipantName={this.props.speedTestParticipantName}
              speedTestDisconnectUserName={this.props.speedTestDisconnectUserName}
            />
          </React.Fragment>
          : null
        }

      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    modules: getModules(state),
    sessionTitle: selectSessionTitle(state),
    admittedParticipants: getAdmittedParticipants(state),
    allParticipants: getAllParticipants(state),
    sessionKey: selectSessionKey(state),
    token: selectUserToken(state),
    webRtcPermissionRequest: getWebRtcPermissionRequest(state),
    webRtcPermissionReply: getWebRtcPermissionReply(state),
    uniqueId: selectCurrentParticipantUniqueId(state),
    userRole: selectUserRole(state),
    headerIcons: getHeaderIcons(state),
    latestUpdatedParticipant: selectLatestUpdatedParticipant(state),
    webRtcPermissionReplyStatus: selectWebRtcPermissionReplyStatus(state),
    isSessionEnded: selectSessionEndedFlag(state),
    isMessageArrived: isMessageArrived(state),
    messagesRead: state.ChatReducer.messagesRead,
    showMessageToast: showMessageToast(state),
    participantId: selectParticipantId(state),
    snapshoteeId: selectSnapshoteeId(state),
    snapshoterId: selectSnapshoterId(state),
    snapshotPermissionReply: selectSnapshotPermissionReply(state),
    isSnapshotTaken: selectIsSnapshotTaken(state),
    sessionStatus: selectSessionStatus(state),
    presenter: selectPresenter(state),
    isLocation: selectLocation(state),
    isLocationSharing: selectLocationSharing(state),
    locationPermissionReply: selectLocationPermissionReply(state),
    locationPermissionReplyStatus: selectLocationPermissionReplyStatus(state),
    locationParticipants: getLocationParticipants(state),
    organiser: selectOrganiser(state),
    activeCanvas: selectActiveCanvas(state),
    frameLockedParticipantId: getFrameLockedParticipantId(state),
    participantLeftUniqueId: getparticipantLeftUniqueId(state),
    participantJoinedUniqueId: getparticipantJoinedUniqueId(state),
    participantDeniedUniqueId: getparticipantDeniedUniqueId(state),
    screenSharingParticipantId: state.RoomMetaDataReducer.roomMetaData.screenSharingParticipantId,
    kmsConnectionStatus: getKmsStatus(state),
    showKmsConnectionStatus: getShowKmsStatus(state),
    logoUrl: state.OrganisationReducer.logoUrl,
    isCallEnded: getCallStatus(state),
    isUserWebCamPresent: state.SessionReducer.isUserWebCamPresent,
    isOrganizer: getIsOrganizer(state),
    isCameraPermissionGranted: getSnapshotCameraPermissionflag(state),
    isCameraBusy: getSnapshotCameraBusyflag(state),
    messages: state.ChatReducer.messages,
    callMediaType: state.SessionReducer.callMediaType,
    loggingLevel: state.SessionReducer.sessionDetails.loggingLevel,
    language: state.LanguageReducer.language,
    passcode: state.SessionReducer.passcode,
    uriIdentifier: state.UserReducer.uriIdentifier,
    customerUriIdentifier: state.OrganisationReducer.customerData.uri_identifier,
    appEmulationPermission: getAppEmulationPermission(state),
    appEmulationPermisssionReply: getAppEmulationPermissionReply(state),
    appEmulationIsSessionEnded: getisSessionEnded(state),
    userName: selectUserName(state),
    customerId: getCustomerId(state),
    snapshotPermissionStatus: state.TostMessageReducer.snapshotPermissionStatus,
    pluginNotInstalledParticipantIds: state.TostMessageReducer.pluginNotInstalledParticipantIds,
    customerCoBrowsePermissionRequest: getCustomerCoBrowsePermissionRequest(state),
    customerCoBrowsePermissionReply: getCustomerCoBrowsePermissionReply(state),
    cobrowseType: selectCoBrowseType(state),
    showCustomerCoBrowse: getShowCustomerCoBrowse(state),
    endInboundCoBrowse: setEndInboundCoBrowse(state),
    isInboundCobrowseMinimize: setIsInboundCobrowseMinimize(state),
    showInboundCoBrowse: getShowInboundCoBrowse(state),
    roomId: getRoomId(state),
    showSnapshot: selectShowSnapshot(state),
    isSnapshotRunning: selectIsSnapShotRunning(state),
    customerCoBrowseStarted: getCustomerCoBrowseStarted(state),
    isUserEvicted: getEvictedParticipantPermissionRequest(state),
    evictedParticipantDetails: getEvictedParticipantDetails(state),
    currentParticipantMediaStatus: state.ParticipantReducer.currentParticipantMediaStatus,
    layoutCode: getLayoutCode(state),
    endUserToken: selectEndUserToken(state),
    coBrowseBaseUrl: selectCoBrowseBaseUrl(state),
    endCustomerCBSession: getEndCustomerCBSession(state),
    recordingMethod: getRecordingMethod(state),
    // recordingMethod: "RECORDING_MANUAL",
    showAudioVideoComponent: getShowAudioVideoComponentFlag(state),
    isRecording: getIsRecording(state),
    recordingTarget: getRecordingTarget(state),
    modalRecordingMessage: getModalRecordingMessage(state),
    isScreenMasking: getIsScreenMasking(state),
    deactiveModules: selectDeactiveModules(state),
    isVideoTransform: getIsVideoTransform(state),
    showPreviewModal: getShowPreviewModal(state),
    subModulesAudioVideo: selectSubModulesAudioVideo(state),
    audioDeviceId: getAudioDeviceId(state),
    videoDeviceId: getVideoDeviceId(state),
    facingMode: getFacingMode(state),
    screenMaskSetting: getScreenMaskSetting(state),
    isReductionLogs: getIsReductionLogs(state),
    isVirtualBackground: getIsVirtualBackground(state),
    selectedBackground: getSelectedBackground(state),
    disableCanvasEdit: getDisableCanvasEdit(state),
    isDisabledMenu: selectIsDisabledMenu(state),
    sessionType: selectSessionType(state),
    contractInfo: getContractInfo(state),
    isContractInfoModalOpened: getIsContractInfoModalOpened(state),
    userProfileData: state.UserReducer.userProfileData,
    sessionName: getSessionName(state),
    orientation: getDeviceOrientation(state),
    operatorExclusiveRecordingControl: getOperatorExclusiveRecordingControl(state),
    disableInitiatingCoBrowse: getDisableInitiatingCoBrowse(state),
    enableVideoBlur: getEnableVideoBlur(state),
    speedTestParticipantId: getSpeedTestParticipantId(state),
    speedTestParticipantName: getSpeedTestParticipantName(state),
    speedTestDisconnectUserName: getSpeedTestDisconnectUserName(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendWebsocketMessage: sendWebsocketMessage,
      displayMessage: displayMessage,
      showMessageArrivedToastAction: showMessageArrivedToastAction,
      addLocationParticipantId: addLocationParticipantId,
      updateLocationPermissionReply: updateLocationPermissionReply,
      stopLocationShare: stopLocationShare,
      setMessagesRead: setMessagesRead,
      setToken
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashHeaderContainer);
